class ScrollablePanel extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.isDown = false
    this.startX = 0
    this.scrollLeft = 0
    this.scrollContainer = null

    this.down = this.down.bind(this)
    this.up = this.up.bind(this)
    this.move = this.move.bind(this)
    this.leave = this.leave.bind(this)
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.scrollContainer = this.els.container.element

    this.listeners.add(this.scrollContainer, 'mouseup', this.up)
    this.listeners.add(this.scrollContainer, 'mousedown', this.down)
    this.listeners.add(this.scrollContainer, 'mousemove', this.move)
    this.listeners.add(this.scrollContainer, 'mouseleave', this.leave)
  }

  get noOverflow () {
    return !this.scrollContainer.scrollWidth > this.scrollContainer.clientWidth
  }

  up (e) {
    this.isDown = false
    this.scrollContainer.removeAttribute('data-dragging')
  }

  down (e) {
    if (this.noOverflow) return

    this.isDown = true
    this.scrollContainer.setAttribute('data-dragging', true)
    this.startX = e.pageX - this.scrollContainer.offsetLeft
    this.scrollLeft = this.scrollContainer.scrollLeft
  }

  move (e) {
    if (!this.isDown) return
    e.preventDefault()
    const x = e.pageX - this.scrollContainer.offsetLeft
    const walk = (x - this.startX) * 3
    this.scrollContainer.scrollLeft = this.scrollLeft - walk
  }

  leave () {
    this.isDown = false
    this.scrollContainer.removeAttribute('data-dragging')
  }
}

if (!customElements.get('scrollable-panel')) {
  customElements.define('scrollable-panel', ScrollablePanel)
}
